module.exports = __webpack_public_path__ + "img/fun.c5429e10.png";